/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForThreats extends models.GovernanceConfigurationBaseForSecurity {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForThreats.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForThreats>): GovernanceConfigurationBaseForThreats {
        let obj = Object.assign(new GovernanceConfigurationBaseForThreats(), model);
        GovernanceConfigurationBaseForThreats.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForThreats>): GovernanceConfigurationBaseForThreats {
        if (!model) return null;
        return GovernanceConfigurationBaseForThreats.newInstance(<GovernanceConfigurationBaseForThreats> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForThreats) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForThreats.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForThreats): boolean {
        if (models.GovernanceConfigurationBaseForSecurity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForThreats.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether realtime notification enabled or not
     */
    enable_realtime_notification: boolean;

}
